import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type PlatFormState = {
  dataPlatform: PlatFormType[];
};

export const platformInitialState: PlatFormState = {
  dataPlatform: [],
};

const slice = createSlice({
  name: 'platform',
  initialState: platformInitialState,
  reducers: {
    setDataPlatform(
      state,
      action: PayloadAction<{
        data: PlatFormType[];
      }>,
    ) {
      const { payload } = action;
      state.dataPlatform = payload.data;
    },
  },
});

export const { setDataPlatform } = slice.actions;
export default slice.reducer;
